import type {Component} from 'grapesjs';
import type {ComponentType} from 'react';
import type {RightPanelSectorProps} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';

export enum TileComplexity {
  SIMPLE = 'simple',
  COMPLEX = 'complex',
}

export interface TileMeta {
  icon: string;
  labelKey: string;
  complexity: TileComplexity;
  shouldShow?: (component: Component) => boolean;
}

export type TileControl = ComponentType<RightPanelSectorProps>;

export interface TileEntry {
  Control: TileControl;
  meta: TileMeta;
}
